import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ub ub-ae" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询")

export function render(_ctx, _cache) {
  const _component_a_spin = _resolveComponent("a-spin")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_button = _resolveComponent("a-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_select, {
      multiple: false,
      placeholder: "全部项目",
      value: _ctx.projectId,
      allowClear: _ctx.allowClear,
      "option-filter-prop": "title",
      "filter-option": false,
      "not-found-content": _ctx.fetching ? undefined : null,
      "show-search": "",
      onSearch: _ctx.initData,
      style: {"width":"300px"},
      onChange: _ctx.handleChange
    }, {
      default: _withCtx(() => [
        (_ctx.fetching)
          ? (_openBlock(), _createBlock(_component_a_spin, {
              key: 0,
              slot: "notFoundContent",
              size: "small"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectList, (item) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: item.id,
            title: item.name,
            value: item.id
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["title", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "allowClear", "not-found-content", "onSearch", "onChange"]),
    _createVNode(_component_a_button, {
      type: "primary",
      style: {"margin-left":"10px"},
      onClick: _ctx.jumpFn
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}